import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "@/store/reducers/authenticationSlice.ts";
import wheelsReducer from "@/store/reducers/wheelsSlice.ts";
import listingReducer from "@/store/reducers/listingSlice.ts";
import mainSlice from "@/store/reducers/mainSlice.ts";
import dealerSlice from "@/store/reducers/dealerslice.ts"; // Adjust path based on your folder structure
import auctionReducer from "@/store/reducers/auctionSlice.ts";
import messageSlice from "@/store/reducers/messageSlice.ts";
import searchReducer from "@/store/reducers/searchSlice.ts";




export const store = configureStore({
    reducer: {
        authentication: authenticationReducer, // Add authentication reducer here
        wheels: wheelsReducer,
        listing: listingReducer,
        main: mainSlice.reducer,
        dealer: dealerSlice.reducer,
        auction: auctionReducer,
        messages: messageSlice.reducer,
        search: searchReducer,

    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export * from './reducers/mainSlice'
export * from './reducers/authenticationSlice'
export * from './reducers/wheelsSlice'
export * from './reducers/listingSlice'
export * from './reducers/auctionSlice'
export * from './reducers/dealerslice'
export * from './reducers/messageSlice'
export * from './reducers/searchSlice'
export * from './hooks'
